// src/mockData.js

export const initialRentals = [
];

// --- W-2 Income ---
export const initialW2s = [
];

export const initialHouseholdWages = [];

export const initialTipIncome = [];

export const initialWaiverPayments = [];

export const initialOtherData = {// --- Line 3c: Child's Dividends (Form 8814) ---
  isFilingStatusConfirmed: false, 
  childsQualifiedDividendsIncluded: false, // Box 1: Included in Line 3a
  childsOrdinaryDividendsIncluded: false,  // Box 2: Included in Line 3b

  // --- Line 4c: IRA Distributions ---
  iraRollover: false,        // Box 1: Rollover
  iraQCD: false,             // Box 2: QCD
  iraHFD: false,
  iraBox3Code: '', 

  // --- Line 5c: Pensions and Annuities ---
  pensionRollover: false,    // Box 1: Rollover
  pensionPSO: false,         // Box 2: PSO
  pensionBox3: false,        // Box 3: Other
  pensionBox3Code: '', 

  // --- Line 6: Social Security ---
  lumpSumElection: false,    // Line 6c
  livedApartEntireYear: false, // Line 6d (MFS only)

  // --- Line 7b: Capital Gains ---
  scheduleDNotRequired: false,      // Box 1: Schedule D not required
  includesChildsCapitalGain: false, // Box 2: Includes child's capital gain
  childCapitalGainAmount: 0,

  // --- Line 16 Taxes ---
  form8814: false,           // Box 1
  taxForm8814Amount: 0,
  form4972: false,           // Box 2
  taxForm4972Amount: 0,
  
  // Box 3 Specific Items
  taxSection962: 0,          // Code "962"
  taxRecaptureEducation: 0,  // Code "ECR"
  taxForm8621: 0,            // Code "1291TAX"
  taxForm8978: 0,            // Code "Form 8978"
  taxSection965i: 0,         // Code "965INC"
  
  // Generic Box 3 (Fallback)
  otherTaxFormNumber: '',    
  otherTaxFormAmount: 0,

  // --- NEW: Schedule 1-A (2025) Fields ---
  tipsW2: 0,            // Line 4a
  tips4137: 0,          // Line 4b
  tipsSelfEmployed: 0,  // Line 5
  overtimePayAmount: 0,         // Part III
  carLoanInterestAmount: 0,     // Part IV
  
  // Part I: MAGI Adjustments
  puertoRicoIncome: 0,          // Line 2a
  foreignHousingExclusion: 0,   // Line 2c
  possessionExclusion: 0,       // Line 2d

  overtimeW2: 0,        // Line 14a
  overtime1099: 0,      // Line 14b
  
  // Part IV: Car Loan Breakdown
  // Vehicle 1
  car1_vin: '',
  car1_totalInterest: 0,
  car1_businessDeduction: 0, // Column (ii)
  
  // Vehicle 2
  car2_vin: '',
  car2_totalInterest: 0,
  car2_businessDeduction: 0, // Column (ii)

  filingStatus: 'Single',
  skipSSN: false,           // For Taxpayer & Spouse
  skipDependentSSN: false,  // For Dependents

  // --- Taxpayer Personal Info ---
  firstName: '',
  lastName: '',
  ssn: '',
  address: '',
  apt: '',
  city: '',
  state: '',
  zip: '',
  qualifyingPersonName: '',
  spouseFirstName: '',  // NEW
  spouseMiddleName: '', // NEW
  spouseLastName: '',   // Already exists
  spouseSSN: '',

  // --- Withholding Breakdown (Line 25c) ---
  unemploymentWithholding: 0,
  socialSecurityWithholding: 0,
  retirementWithholding: 0,
  otherFederalWithholding: 0,

  // --- Payments & Penalties ---
  estimatedTaxPayments: 0,       // Line 26
  formerSpouseSSN: '',

  // --- Line 27: Earned Income Credit ---
  earnedIncomeCredit: 0,
  eicBox1: false, // Age Exception (Born 1998-2004)
  eicBox2: false, // Former Foster/Homeless Youth

  amountAppliedToNextYear: 0,    // Line 36
  estimatedTaxPenalty: 0,        // Line 38

  // --- Refund Direct Deposit Info ---
  refundRoutingNumber: '',
  refundAccountNumber: '',
  refundAccountType: 'Checking',

  // --- Refundable Credits ---
  refundableEducationCredit: 0,  // Line 29
  isForeignAddress: false,    // Toggle
  foreignCountry: '',         // Input 1
  foreignProvince: '',        // Input 2
  foreignPostalCode: '',      // Input 3

  // --- New Income/Election Fields ---
  nonTaxableCombatPayAmount: 0,
  lumpSumElection: false,
  nonresidentAlienSpouse: false,
  nonresidentAlienSpouseName: '',
  nonresidentAlienStatement: null,
  receivedDigitalAssets: false,
  canBeClaimedAsDependent: false,
  spouseCanBeClaimedAsDependent: false,
  spouseItemizes: false,
  isDualStatusAlien: false,
  priorYearTax: 0,
  isOver65: false,
  isBlind: false,
  spouseIsOver65: false,
  spouseIsBlind: false,
  dependents: [],
  careProviders: [],
  
  // --- Investment & Income Fields ---
  capitalGainDistributions: 0, // Updated: Used for Schedule D Line 13
  ordinaryDividends: 0,
  qualifiedDividends: 0,
  taxableInterest: 0,
  taxExemptInterest: 0,
  
  unemploymentCompensation: 0,
  educatorExpenses: 0,
  hsaDeduction: 0,
  selfEmployedHealthInsurance: 0,
  selfEmployedRetirementDeduction: 0,
  earlyWithdrawalPenalty: 0,
  netOperatingLoss: 0,
  cancellationOfDebt: 0,
  foreignEarnedIncomeExclusion: 0,
  incomeFrom8853: 0,
  incomeFrom8889: 0,
  alaskaDividends: 0,
  hobbyIncome: 0,
  stockOptions: 0,
  personalPropertyRental: 0,
  olympicPrizeMoney: 0,
  section951a: 0,
  section951Aa: 0,
  excessBusinessLoss: 0,
  ableDistributions: 0,
  scholarships: 0,
  nonqualifiedPension: 0,
  incarceratedWages: 0,
  digitalAssetOrdinaryIncome: 0,
  gamblingWinnings: 0,
  juryDutyPay: 0,
  prizesAndAwards: 0,
  rtaaPayments: 0,                     // Reemployment trade adjustment assistanc
  disasterReliefPayments: 0,           // Taxable disaster relief
  coverdellTaxableDistributions: 0,    // Coverdell ESA taxable distributions
  line8z_other_amount: 0,              // Custom other income
  line8z_other_description: '',
  line17a_3468: false,
  line17a_3468_form: '4255',
  line17a_NEPE3458: false,
  line17a_NEPE3458_form: '3468',
  line17a_NMCR: false,
  line17a_ECCFR: false,
  line17a_6418: false,

  // Line 17z - Multiple tax types (checkboxes)
  line17z_PWA7210: false,
  line17z_PWA8933: false,
  line17z_NPWA: false,
  line17z_Form8978: false,
  line17z_other: false,
  line17z_other_description: '',

  // Line 8z - Multiple income types (already have individual fields)
  line8z_other: false,
  // --- Adoption Credit Data ---
  adoptionCredit: {
    form8839_year2024_line2: 0,
    adoptionCreditPrevYear: false,
    form8839_year2024_line3: 0,
    form8839_year2024_line4: 0,
    form8839_year2024_line5: 0,
    form8839_year2024_line6: 0,
    form8839_year2024_line7: 0,
    form8839_year2024_line8: 0,
    form8839_year2024_line9: 0,
    form8839_year2024_line11: 0,
    form8839_year2024_line12: 0,
    form8839_year2024_line14: 0, // Used for Credit Limit Worksheet
    form8839_year2024_line15: 0,
    form8839_year2024_line16: 0,
    hasCarryforward: false,
    usedWorksheetIn2023: false,
    carryforward_line1: 0,
    carryforward_2019: 0,
    carryforward_2020: 0,
    carryforward_2021: 0,
    carryforward_2022: 0,
    carryforward_2023: 0,
    carryforward_line16: 0,
    totalCarryforward: 0,
    receivedEmployerBenefits: false,
    taxablePriorYearBenefitsByChild: {},
    taxableCurrentYearBenefitsByChild: {},
    totalCurrentYearBenefits: 0,
    finalChildCreditOrCarryforward: {},
    perChildCreditLimitation: {},
    totalPerChildCreditLimitation: 0,
    isLimitationGreaterThanBenefits: false,
    finalBenefitCalculation: 0,
    minBenefitComparisonByChild: {},
    benefitsByChild: {},
    expensesByChild: {},
    adjustedExpensesByChild: {},
    lineEleven: {},
  },
  thirdPartyDesignee: {
    wantsToDesignate: false,
    name: '',
    phone: '',
    pin: ''
  },
  signatures: {
    primarySignature: '',
    primaryDate: new Date().toISOString().split('T')[0],
    primaryOccupation: '',
    primaryIpPin: '',
    spouseSignature: '',
    spouseDate: new Date().toISOString().split('T')[0],
    spouseOccupation: '',
    spouseIpPin: '',
    phoneNumber: '',
    emailAddress: ''
  },
  paidPreparer: {
    usedPaidPreparer: false,
    preparerName: '',
    ptin: '',
    firmName: '',
    firmEin: '',
    phone: '',
    address: '',
    selfEmployed: false
  },
  dependentCareBenefits: [], 
  dependentCare: {
    receivedBenefits: false,
    paidForPriorYearCare: false,
    priorYearExpensesPaidInCurrentYear: 0,
    forfeitedOrCarriedOverAmount: 0, 
    priorYearQualifyingPersonsCount: 0,
    priorYearBenefitsReceivedLessExclusions: 0,
    priorYearUserEarnedIncome: 0,
    priorYearSpouseEarnedIncome: 0,
    worksheetA10: 0,
    priorYearAGI: 0,
    prevYearDec: 0,
    form2441_line9b: 0,
    form2441_line15: 0,
    form2441_line16: 0,
    form2441_line17: 0,
    form2441_line18: 0,
    form2441_line19: 0,
    form2441_line20: 0,
    form2441_line21: 0,
    form2441_line22: 0,
    form2441_line23: 0,
    form2441_line24: 0,
    dependentBenefitsFromOwnBusiness: false,
    dependentBenefitsFromOwnBusinessAmount: 0,
    line29Zero: false,
    priorYearCreditBaseAmount: 0, 
    totalExpenses: 0,
    spouseEarnedIncome: 0,
    userEarnedIncome: 0,
    wasForWorkOrJobSearch: false,
    providerWasNotSpouseOrDependent: false,
    livedApartFromSpouse: false,
    homeWasQualifyingPersonsMainHome: false,
    paidMoreThanHalfCostOfHome: false,
    userWasStudentOrDisabled: false,
    spouseWasStudentOrDisabled: false,
    userMonthsAsStudentOrDisabled: 0,
    userIncomeForMonths: 0,
    spouseMonthsAsStudentOrDisabled: 0,
    spouseIncomeForMonths: 0,
  },
  form8919: {
    performedServicesForFirm: false,
    shouldHaveBeenEmployee: false,
    noTaxesWithheld: false,
    reasonCodeApplies: false,
    reasonCode: '',
    firms: [],
    taxPaidOnTips: 0,
  },
  alimonyReceived: 0,
  divorceDate: '',
  alimonyPaid: 0,              // Line 19a
  alimonyRecipientSSN: '',     // Line 19b
  alimonyPaidDivorceDate: '',
  taxableStateRefund: 0, 
  juryDutyPayTurnedOver: 0,          // Line 24a
  personalPropertyRentalExpenses: 0, // Line 24b
  excessAptcRepayment: 0,
  repayNewCleanVehicle: 0,
  repayOldCleanVehicle: 0,
  recaptureEPE: 0,
  excessivePaymentsEPE: 0,
  otherAdditionsTax: 0,
  otherAdditionsTaxDescription: "",
  amtTax: 0,
  
  unreportedTipTax: 0,
  uncollectedTax: 0,
  taxOnIras: 0,
  suppressForm5329: true, // This should check the box on Line 8
  homebuyerCreditRepayment: 0,
  recaptureMortgageSubsidy: 0,   // Line 17a (Form 8828)
  line17aType: '', // e.g., "3468", "NEPE3458", "NMCR", "ECCFR", "6418(g)(3)"
  line17aFormNumber: '',
  line17aAmount: 0,
  additionalTax8812: 0,          // Line 19: Additional tax from Schedule 8812
  section965TaxInstallment: 0,
  taxOnTrustAccumulation: 0,     // Line 17b (Form 4970)
  exciseTaxInsiderStock: 0,      // Line 17c (Form 7248)
  lookBackInterest8697: 0,       // Line 17d (Form 8697)
  lookBackInterest8866: 0,       // Line 17e (Form 8866)
  goldenParachuteTax: 0,         // Line 17k (Golden Parachute)
  line17zAmount: 0,        // Line 17z (Other)
  line17zType: '',
  uncollectedSocialSecurityMedicare: 0,    // Line 17f (Form 4137)
  uncollectedSocialSecurityRRTA: 0,        // Line 17g (Form 8919)
  additionalTaxIRA: 0,                     // Line 17h (Form 5329)
  householdEmploymentTax: 0,               // Line 17i (Schedule H)
  repaymentFirstTimeBuyer: 0,              // Line 17j (Form 5405)
  additionalMedicareTax: 0,                // Line 17l (Form 8959)
  netInvestmentIncomeTax: 0,               // Line 17m (Form 8960)
  section965Tax: 0,                        // Line 17n (Section 965)
  section951aTax: 0,                       // Line 17o (Section 951A)
  section461lExcessLoss: 0,                // Line 17p (Section 461(l))
  deferredTaxSection1061: 0,               // Line 17q (Section 1061(a))
  iraEarlyDistAmount: 0,    // Amount withdrawn before 59.5
  iraExceptionAmount: 0,    // Amount used for qualified exceptions (Ed, Home, etc.)
  strikeBenefits: 0,
  disabilityPensionPreRetirement: 0,
  correctiveDistributions: 0,
  totalIraDistributions: 0,
  taxableIraDistributions: 0,
  totalPensionsAnnuities: 0,
  taxablePensionsAnnuities: 0,
  totalSocialSecurityBenefits: 0,
  taxableSocialSecurityBenefits: 0,
  foreignTaxCredit: 0,             // Line 1 (Form 1116)
  residentialCleanEnergyCredit: 0, // Line 5a (Form 5695)
  energyEfficientHomeCredit: 0,    // Line 5b (Form 5695)
  
  // Line 6 Breakdown
  generalBusinessCredit: 0,        // 6a (Form 3800)
  priorYearMinTaxCredit: 0,        // 6b (Form 8801)
  elderlyDisabledCredit: 0,        // 6d (Schedule R)
  cleanVehicleCredit: 0,           // 6f (Form 8936)
  mortgageInterestCredit: 0,       // 6g (Form 8396)
  dcHomebuyerCredit: 0,            // 6h (Form 8859) - NEW
  qualifiedElectricVehicleCredit: 0, // 6i (Form 8834) - NEW
  alternativeFuelVehicleCredit: 0, // 6j (Form 8911) - NEW
  taxCreditBonds: 0,               // 6k (Form 8912) - NEW
  form8978Credit: 0,               // 6l (Form 8978) - NEW
  previouslyOwnedCleanVehicle: 0,  // 6m (Form 8936)
  line6zAmount: 0,
  line6zDescription: '', // Simple text input

  // --- Schedule 3 Line 13z (Other Refundable Credits) ---
  line13zAmount: 0,
  line13zDescription: '',

  // --- Schedule 3 Part II (Refundable Credits) ---
  netPremiumTaxCredit: 0,          // Line 9
  amountPaidWithExtension: 0,      // Line 10
  excessSocialSecurityTax: 0,      // Line 11
  fuelTaxCredit: 0,                // Line 12 (Form 4136)
  // --- NEW: Missing Schedule 1 Part I (Income) ---
  otherGainsLosses: 0,       // Line 4 (Form 4797)
  farmIncome: 0,             // Line 6 (Schedule F)

  // --- NEW: Missing Schedule 1 Part II (Adjustments) ---
  reservistExpenses: 0,      // Line 12 (Form 2106)
  movingExpenses: 0,         // Line 14 (Form 3903 - Military)
  archerMsaDeduction: 0,     // Line 23 (Form 8853)
  otherAdjustments24z: 0,    // Line 24z (Other adjustments)
  otherAdjustments24zDescription: '',

  // --- NEW: Missing Form 1040 Line 16 Taxes ---
  form8814: false,           // Checkbox
  taxForm8814Amount: 0,      // Amount
  form4972: false,           // Checkbox
  taxForm4972Amount: 0,      // Amount

  otherTaxFormNumber: '',    // Checkbox 3 (Form Number)
  otherTaxFormAmount: 0,     // Checkbox 3 (Amount) - Note: usually added to total

  // --- Line 27: Earned Income Credit ---
  earnedIncomeCredit: 0,
  clergyFilingSE: false,     // Line 27b (Clergy)
  doNotClaimEIC: false,      // Line 27c (No)

  // --- Line 28: Additional Child Tax Credit ---
  manualAdditionalChildTaxCredit: 0, // <--- ADDED THIS MISSING FIELD
  line28Form8862: false,             // Checkbox: Form 8862 required

  // --- 2025 Header Changes ---
  isDeceased: false,
  dateOfDeath: '',           // Taxpayer Date of Death
  isSpouseDeceased: false,
  spouseDateOfDeath: '',     // Spouse Date of Death
  inCombatZone: false,       // "Combat Zone" flag in header
  filedPursuantTo301: false, // "Filed pursuant to section 301.9100-2"

  // --- 2025 Header: Fiscal Year ---
  isFiscalYearFiler: false,
  fiscalYearStartMonth: '',
  fiscalYearStartDay: '',
  fiscalYearEndMonth: '',
  fiscalYearEndDay: '',
  fiscalYearEndYear: '',

  // --- 2025 Header: Special Processing ---
  filedPursuantTo301: false, // Section 301.9100-2
  inCombatZone: false,       // Combat Zone
  isDeceased: false,
  dateOfDeath: '',
  isSpouseDeceased: false,
  spouseDateOfDeath: '',

  // --- Address Block Extras ---
  mainHomeInUS: false,       // "Main home in US" checkbox
  presidentialCampaign: {
    you: false,
    spouse: false
  },

  showScheduleCDetails: false,

  // --- NEW: Missing Schedule 3 Part I (Credits) ---
  educationCreditNonRefundable: 0, // Line 3 (Form 8863)
  
  // Line 13 Breakdown
  form2439Payment: 0,              // 13a (Form 2439) - NEW
  section1341Credit: 0,            // 13b (Section 1341) - NEW
  electivePaymentElection: 0,      // 13c (Form 3800) - NEW
  deferred965Liability: 0,         // 13d (Section 965) - NEW
  hasSchedule1AdditionalIncome: false, 
  hasSchedule2: false,
  hasSchedule3: false,
  manualW2Wages: null,          // Overrides W2Grid calculation
  manualBusinessIncome: null,   // Overrides IncomeGrid/ExpensesGrid calculation
  manualRentalIncome: null,     // Overrides RentalIncomeGrid calculation
  manualCapitalGains: null,     // Overrides InvestmentsGrid calculation
  manualBusinessExpenses: null, // Schedule C
  manualMedicalExpenses: null,  // Schedule A
  manualStateTaxes: null,
  manualGeneralSalesTax: null,
  manualRealEstateTaxes: null,
  manualPersonalPropertyTaxes: null,
  manualMortgageInterest: null,
  manualCharityCash: null,
  manualCharityNonCash: null,
  manualDepreciation: null, // <--- ADD THIS LINE
  manualHouseholdWages: null,
  manualTipIncome: null,
  manualWaiverPayments: null,
  // --- Schedule B Data ---
  interestPayers: [], // Array for Part I
  dividendPayers: [], // Array for Part II
  
  // Keep existing totals as fallbacks or calculated values
  taxableInterest: 0, 
  taxExemptInterest: 0,
  ordinaryDividends: 0,
  qualifiedDividends: 0,
  foreignAccounts: false,       // Question 7a
  fileFbar: false,              // Question 7a (part 2)
  foreignAccountCountry: '',    // Question 7a (part 3)
  foreignTrust: false,          // Question 8
  excludableSavingsBondInterest: 0, // Schedule B Line 3
  businessVehicle: {
    inServiceDate: '',
    totalMiles: 0,
    businessMiles: 0,
    commutingMiles: 0,
    otherMiles: 0,
    hasEvidence: false,
    isEvidenceWritten: false,
    availableForPersonalUse: false
  },
  homeOffice: {
    areaUsed: 0,
    totalArea: 0,
    simplifiedMethod: true,
    deductionAmount: 0
  },
  itemizedDeductions: {
    mortgageProceedsNotUsedForHome: false,
    // Medical
    medicalExpenses: 0,

    // Taxes (SALT)
    stateAndLocalIncomeTaxes: 0, // Line 5a
    generalSalesTax: 0, 
    realEstateTaxes: 0,          // Line 5b
    personalPropertyTaxes: 0,    // Line 5c
    otherTaxes: 0,               // Line 6
    otherTaxesDescription: '',

    // Interest
    mortgageInterest: 0,         // Line 8a (Form 1098)
    mortgageInterestNot1098: 0,  // Line 8b
    mortgageInterestPayee: '',   // Line 8b Payee
    pointsNot1098: 0,            // Line 8c
    mortgageInsurancePremiums: 0,// Line 8d
    investmentInterest: 0,       // Line 9

    // Charity
    charitableDonationsCash: 0,    // Line 11
    charitableDonationsNonCash: 0, // Line 12
    charitableCarryover: 0,        // Line 13

    // Other
    otherDeductions: 0,            // Line 16
    casualtyCalculator: {
        totalLoss: 0,
        insuranceReimbursement: 0,
        isFederallyDeclared: false
    },
    // NEW: Other Itemized Deductions (Line 16)
    line16Details: {
        gamblingLosses: 0,
        netQualifiedDisasterLoss: 0, // Form 4684 Line 15
        impairmentWorkExpenses: 0,
        claimOfRightRepayment: 0,    // > $3,000
        unrecoveredPension: 0,
        otherMiscAmount: 0,
        otherMiscDescription: ''
    },
    forceItemized: false, 
    
    // Legacy fields (kept for backward compatibility with summaries)
    stateAndLocalTaxes: 0, 
    charitableDonations: 0,
  },
  retirementContributions: 0,
  capitalLossCarryover: 0,
  iraContribution: 0,
  studentLoanInterest: 0,
  scheduleSE: {
    useNonfarmOptionalMethod: false, // The master toggle
    metSelfEmploymentTest: false,    // "Did you have $400+ net earnings in 2 of prior 3 years?"
    ministerFiledForm4361: false,
  },
  childTaxCredit: {
    eligible: false,
    amount: 0,
  },
  disposedOfQOF: false, // Question 1
  acquiredQOF: false,   // Question 2
  schedD_line4_shortTermFormGains: 0, // Form 6252, 4684, 6781, 8824
  schedD_line5_shortTermK1Gains: 0,   // Schedule K-1 (Partnerships, etc.)
  
  schedD_line11_longTermFormGains: 0, // Form 4797, 2439, 6252, etc.
  schedD_line12_longTermK1Gains: 0,
  capitalLossCarryoverShort: 0, // From 2024 Schedule D, Line 6
  capitalLossCarryoverLong: 0,  // From 2024 Schedule D, Line 14
  
  // Special Gain Types
  collectiblesGain: 0,          // 28% Rate Gain (Art, Coins, etc.)
  unrecapturedSection1250Gain: 0, // Real Estate Depreciation Recapture
};

// --- Freelance Income & Expenses ---
export const initialIncome = [
];

export const initialExpenses = [
];

// --- Assets & Depreciation ---
export const initialAssets = [
];

// --- Investments & Capital Gains (Schedule D) ---
export const initialInvestments = [
];

// --- Constants ---
export const INCOME_CATEGORIES = ["Salary", "Freelance", "Investment", "Other Income"];
export const EXPENSE_CATEGORIES = [
  "Business", 
  "Medical", 
  "State Taxes", 
  "Real Estate Taxes", 
  "Personal Property Taxes",
  "Mortgage Interest", 
  "Charity (Cash)", 
  "Charity (Goods)",
  "Software", 
  "Rent", 
  "Utilities", 
  "Travel", 
  "Other"
];

export const initialScheduleC = [
  {
    id: 'biz-1',
    businessName: '',
    businessAddress: '', 
    businessCity: '',   // Ensure these are here
    businessState: '', 
    businessZip: '',   
    principalBusiness: '',
    code: '', // NAICS Code
    ein: '',
    accountingMethod: 'Cash', 
    accountingMethodOtherDescription: '',
    materiallyParticipated: true, 
    startedIn2024: false, // Line H (2024)
    requiredToFile1099: false, // Line I
    didFile1099: false, // Line J
    statutoryEmployee: false,
    
    // Part I: Income
    grossReceipts: 0, // Line 1
    returnsAndAllowances: 0, // Line 2
    otherIncome: 0, // Line 6
    
    // Part II: Expenses
    advertising: 0, 
    carAndTruckExpenses: 0, 
    commissions: 0, 
    contractLabor: 0, 
    depletion: 0, 
    depreciation: 0, 
    employeeBenefitPrograms: 0, 
    insurance: 0, 
    mortgageInterest: 0, 
    otherInterest: 0, 
    legalAndProfessional: 0, 
    officeExpense: 0, 
    pensionAndProfitSharing: 0, 
    rentVehiclesMachinery: 0, // Line 20a (Vehicles, machinery, equipment)
    rentOtherProperty: 0,     // Line 20b (Real property, office space, etc.)
    repairsAndMaintenance: 0, 
    supplies: 0, 
    taxesAndLicenses: 0, 
    travel: 0, 
    meals: 0, // 50% deductible
    utilities: 0, 
    wages: 0, 
    otherExpenses: [], // [{ description: '', amount: 0 }]
    
    // Part III: Cost of Goods Sold
    inventoryMethod: 'Cost', // Line 33: 'Cost', 'Lower', or 'Other'
    inventoryMethodOtherDescription: '', // If 'Other'
    inventoryChange: false, // Line 34: Did you change methods?
    inventoryChangeExplanation: '', // If 'Yes'
    inventoryBeginning: 0,
    purchases: 0,
    otherCosts: 0,
    costOfLabor: 0,
    materialsAndSupplies: 0,
    inventoryEnd: 0,
    
    // Part IV: Vehicle Info
    vehicleInfo: {
      inServiceDate: '',
      businessMiles: 0,
      commutingMiles: 0,
      otherMiles: 0,
      availableForPersonalUse: false, // Line 45
      anotherVehicleAvailable: false, // Line 46
      hasEvidence: false,             // Line 47a
      isEvidenceWritten: false        // Line 47b
    },

    // Home Office (Simplified Method)
    homeOffice: {
      areaUsed: 0,
      totalArea: 0
    },
    exemptNotaryIncome: 0, // Income earned as a notary (exempt from SE tax)
    conservationReserveProgramPayments: 0, // CRP Payments (Line 1b)
    churchEmployeeIncome: 0, // Special rule for church employees
  }
];

export const initialScheduleE = {
  paymentsRequiring1099: false, // Line A
  didFile1099: false,           // Line B
  
  // Part I: Real Estate
  properties: [
  ],

  // Part II: Partnerships & S-Corps
  partnerships: [
  ],
  
  estates: [],
  remics: []
};